module.exports = __webpack_public_path__ + "static/img/AI1.b3047417.png";